import { Divider } from "antd";

const Gammaked = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">
          INDICATIONS AND USAGE
        </p>

        <div className="m-2">
          GAMMAKED™ [Immune Globulin Injection (Human) 10% Caprylate/Chromatography Purified] is an immune globulin
          injection that is indicated to treat primary humoral immunodeficiency (PI) in patients 2 years of age and
          older, idiopathic thrombocytopenic purpura (ITP) in adults and children, and chronic inflammatory
          demyelinating polyneuropathy (CIDP) in adults.
        </div>

        <p className="m-2 underline font-bold">IMPORTANT SAFETY INFORMATION</p>

        <div className="m-2 border border-black p-2 font-bold">
          Boxed Warning: Thrombosis, Renal Dysfunction and Acute Renal Failure
          <ul className="list-disc m-2 ml-10">
            <li className="my-2">Thrombosis may occur with immune globulin products, including GAMMAKED. Risk factors may include:
              advanced age, prolonged immobilization, hypercoagulable conditions, history of venous or arterial
              thrombosis, use of estrogens, indwelling vascular catheters, hyperviscosity, and cardiovascular risk
              factors. Thrombosis may occur in the absence of known risk factors.
            </li>

            <li className="my-2">For patients at risk of thrombosis, administer GAMMAKED at the minimum dose and infusion rate
              practicable. Ensure adequate hydration in patients before administration. Monitor for signs and symptoms
              of thrombosis and assess blood viscosity in patients at risk for hyperviscosity.
            </li>

            <li className="my-2">Renal dysfunction, acute renal failure, osmotic nephrosis, and death may occur with immune globulin
              intravenous (IGIV) products in predisposed patients. Patients predisposed to renal dysfunction include
              those with any degree of pre-existing renal insufficiency, diabetes mellitus, age greater than 65, volume
              depletion, sepsis, paraproteinemia, or patients receiving known nephrotoxic drugs.
            </li>

            <li className="my-2">Renal dysfunction and acute renal failure occur more commonly in patients receiving IGIV products
              containing sucrose. GAMMAKED does not contain sucrose.
            </li>

            <li className="my-2">For patients at risk of renal dysfunction or failure, administer GAMMAKED at the minimum concentration
              available and the minimum infusion rate practicable.
            </li>
          </ul>
        </div>

        <p className="m-2 mt-6 font-bold">
          CONTRAINDICATIONS
        </p>

        <p className="m-2">
          GAMMAKED is contraindicated in patients who have had an anaphylactic or severe systemic reaction to human
          immunoglobulin. It is also contraindicated in IgA deficient patients with antibodies against IgA and history
          of hypersensitivity. Have epinephrine available immediately to treat any acute severe hypersensitivity
          reactions.
        </p>

        <p className="m-2 font-bold">
          WARNINGS AND PRECAUTIONS
        </p>

        <p className="m-2">
          <b>Hypersensitivity: </b>
          Severe hypersensitivity reactions may occur with IGIV products, including GAMMAKED. In case of
          hypersensitivity, discontinue GAMMAKED infusion immediately and institute appropriate treatment. GAMMAKED
          contains trace amounts of IgA (average 46 micrograms/mL). Patients with known antibodies to IgA may have a
          greater risk of developing potentially severe hypersensitivity and anaphylactic reactions. It is
          contraindicated in IgA deficient patients with antibodies against IgA and history of hypersensitivity
          reaction.
        </p>

        <p className="m-2">
          <b>Renal Failure: </b>
          Acute renal dysfunction/failure, acute tubular necrosis, proximal tubular nephropathy, osmotic nephrosis and
          death may occur upon use of IGIV products, especially those containing sucrose. GAMMAKED does not contain
          sucrose. Ensure that patients are not volume depleted prior to the initiation of the infusion of GAMMAKED.
          Periodic monitoring of renal function and urine output is particularly important in patients judged to have a
          potential increased risk for developing acute renal failure. Assess renal function, including measurement of
          blood urea nitrogen (BUN)/serum creatinine, prior to the initial infusion of GAMMAKED and again at appropriate
          intervals thereafter. If renal function deteriorates, consider discontinuation of GAMMAKED. For patients
          judged to be at risk for developing renal dysfunction, including patients with any degree of pre-existing
          renal insufficiency or risk factors for renal insufficiency, administer GAMMAKED at the minimum infusion rate
          practicable [less than 8 mg/kg/min (0.08 mL/kg/min)].
        </p>

        <p className="m-2">
          <b>Hyperproteinemia, Increased Serum Viscosity, and Hyponatremia: </b>
          Hyperproteinemia, increased serum viscosity, and hyponatremia may occur in patients receiving IGIV therapy,
          including GAMMAKED. It is clinically critical to distinguish true hyponatremia from a pseudohyponatremia that
          is associated with concomitant decreased calculated serum osmolality or elevated osmolar gap, because
          treatment aimed at decreasing serum free water in patients with pseudohyponatremia may lead to volume
          depletion, a further increase in serum viscosity and a possible predisposition to thrombosis.
        </p>

        <p className="m-2">
          <b>Aseptic Meningitis Syndrome (AMS): </b>
          Aseptic Meningitis Syndrome (AMS) may occur infrequently, especially with high doses or rapid infusion.
        </p>

        <p className="m-2">
          <b>Hemolysis: </b>
          Hemolysis, either intravascular or due to enhanced red blood cell (RBC) sequestration, can develop subsequent
          to GAMMAKED treatment. Risk factors include high doses and non-O blood group. Closely monitor patients for
          hemolysis and hemolytic anemia, especially in patients with pre-existing anemia and/or cardiovascular or
          pulmonary compromise.
        </p>

        <p className="m-2">
          <b>Transfusion-related Acute Lung Injury (TRALI): </b>
          Noncardiogenic pulmonary edema may occur in patients following treatment with IGIV products, including
          GAMMAKED. Monitor patients for pulmonary adverse reactions (transfusion-related acute lung injury [TRALI]).
        </p>

        <p className="m-2">
          <b>Volume Overload: </b>
          The high dose regimen (1g/kg x 1-2 days) is not recommended for individuals with expanded fluid volumes or
          where fluid volume may be a concern.
        </p>

        <p className="m-2">
          <b>Transmission of Infectious Agents: </b>
          GAMMAKED is made from human plasma. Because this product is made from human plasma, it may carry a risk of
          transmitting infectious agents, e.g., viruses, the variant Creutzfeldt-Jakob disease (vCJD) agent and,
          theoretically, the Creutzfeldt- Jakob disease (CJD) agent.
        </p>

        <p className="m-2">
          <b>Hematoma Formation: </b>
          GAMMAKED is not approved for subcutaneous use in patients with ITP. Due to the potential risk of hematoma
          formation, GAMMAKED should not be administered subcutaneously in patients with ITP.
        </p>

        <p className="m-2">
          <b>Interference with Laboratory Tests: </b>
          After infusion of IgG, the transitory rise of the various passively transferred antibodies in the patient’s
          blood may yield positive serological testing results, with the potential for misleading interpretation.
        </p>

        <p className="m-2 font-bold">ADVERSE REACTIONS</p>

        <p className="m-2">
          In clinical studies, the most common adverse reactions with GAMMAKED (≥5% of subjects) were:
          <b> (in PI intravenous) </b>
          cough increased, rhinitis, pharyngitis, headache, asthma, nausea, fever, diarrhea, and sinusitis;
          <b> (in PI subcutaneous) </b>
          local infusion site reactions, fatigue, headache, upper respiratory tract infection, arthralgia, diarrhea, nausea, sinusitis, bronchitis, depression, allergic dermatitis, erythema, migraine, myalgia, viral infection, and pyrexia;
          <b> (in ITP) </b>
          headache, ecchymosis, vomiting, fever, nausea, rash, abdominal pain, back pain, and dyspepsia;
          <b> (in CIDP) </b>
          headache, pyrexia, hypertension, chills, rash, nausea, arthralgia, and asthenia.
        </p>


        <div>
          <p className="m-2">
            <b>
              Please&nbsp;
              <a
                target="_blank"
                href="/Gammaked-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                click here
              </a>
              &nbsp;for the Full Prescribing Information for complete prescribing details including Boxed Warning,
              contraindications and dosing and administration information.
            </b>
          </p>
        </div>

      </div>
    </>
  );
};

export default Gammaked;
